// extracted by mini-css-extract-plugin
module.exports = {"root":"FullServiceBadge-module--root--2MKKk","text":"FullServiceBadge-module--text--3dC--","linkContainer":"FullServiceBadge-module--linkContainer--1Peec"};